import React from "react";
import I18n from "i18n-js";

import Timeline from "./Timeline";

const ObjectiveTimeline = ({ objective }) => {

  return (
    <div className="objective-timeline">
      <span className="section-title">{I18n.t("pdp.timeline.title")}</span>
      <Timeline
        objective={objective}
        start={objective?.started_at}
        end={objective?.completed_at || objective?.target_date}
        tasks={objective?.tasks}
      />
    </div>
  );
}

export default ObjectiveTimeline;
